<template>
  <div class="container d-flex mt-5 justify-content-center text-center">
    <div class="form-login">
      <img
        class="mb-4"
        src="https://getbootstrap.com/docs/4.0/assets/img/bootstrap-stack.png"
        alt=""
        width="140"
        height="140"
      >
      <h1 class="h3 mb-3 font-weight-normal">
        Please login
      </h1>
      <label
        for="inputEmail"
        class="sr-only"
      >
        Email address
      </label>
      <input
        id="inputEmail"
        v-model="user.email"

        type="email"
        class="form-control mb-2"
        placeholder="Email address"
        required=""
        autofocus=""
      >
      <label
        for="inputPassword"
        class="sr-only"
      >
        Password
      </label>
      <input
        id="inputPassword"
        v-model="user.password"

        type="password"
        class="form-control mb-3"
        placeholder="Password"
        required=""
      >
      <button
        class="btn btn-lg btn-primary btn-block"
        type="submit"

        :disabled="isWaiting"
        @click.stop="login"
      >
        Login
      </button>
    </div>
  </div>
</template>
<script>
import { mapMutations, mapGetters } from 'vuex';
import { API } from '@/services/';
import { API_LOGIN } from '@/helpers/config';

export default {
  data: () => ({
    isWaiting: false,
    user: {
      email: null,
      password: null,
    },
  }),
  computed: {
    ...mapGetters(['jwtToken']),
  },
  methods: {
    ...mapMutations(['setJwtToken']),
    login() {
      this.isWaiting = true;

      API
        .post(API_LOGIN, this.user)
        .then((response) => {
          this.isWaiting = false;
          this.setJwtToken(response.data.token);
          this.$router.push('/admin');
        })
        .catch((e) => {
          // eslint-disable-next-line
          console.log(e);
          this.isWaiting = false;
        });
    },
  },
};
</script>
<style scoped>
  .form-login {
    width: 300px;
  }
</style>
